
import React, { useState } from "react";
import Logo from "../Assets/logo.png";
import { HiOutlineBars3 } from "react-icons/hi2";
import { MdApartment } from "react-icons/md";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { MdHome, MdInfo, MdDesignServices, MdCall } from "react-icons/md";
import { useLanguage } from "../i18n";
const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const scrollToSection = (id) => {
    const targetId = id?.toString().replace(/^#/, "");
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setOpenMenu(false);
  };

  const menuOptions = [
    {
      text: t.home,
      icon: <MdHome />,
      id: "home",
    },
    {
      text: t.about,
      icon: <MdInfo />,
      id: "about",
    },
    {
      text: t.whyUs,
      icon: <MdDesignServices />,
      id: "why-us",
    },
    {
      text: t.products,
      icon: <MdApartment />,
      id: "products",
    },
    {
      text: t.contact,
      icon: <MdCall />,
      id: "contact",
    },
  ];

  return (
    <nav>
      <div className="nav-logo-container">
        <img src={Logo} alt="Pranesh Enterprises" />
      </div>
      <div className="navbar-links-container">
        {menuOptions.map((item) => (
          <a
            key={item.text}
            href={`#${item.id}`}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(item.id);
            }}
          >
            {item.text}
          </a>
        ))}
      </div>
      <label className="language-selector"><span className="sr-only">Language</span><select value={language} onChange={(event) => setLanguage(event.target.value)} aria-label="Choose language"><option value="en">🇬🇧 English</option><option value="ar">🇸🇦 العربية</option><option value="zh">🇨🇳 中文</option><option value="ja">🇯🇵 日本語</option></select></label>
      <div className="navbar-menu-container">
        <button
          type="button"
          className="menu-button"
          onClick={() => setOpenMenu(true)}
          aria-label="Open navigation menu"
        >
          <HiOutlineBars3 />
        </button>
      </div>
      <Drawer
        open={openMenu}
        onClose={() => setOpenMenu(false)}
        anchor="right"
        PaperProps={{
          sx: {
            background: "#061127",
            color: "#eaf4fb",
            borderLeft: "1px solid rgba(112, 224, 177, 0.18)",
          },
        }}
      >
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={() => setOpenMenu(false)}
          onKeyDown={() => setOpenMenu(false)}
        >
          <List>
            {menuOptions.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton
                  onClick={() => scrollToSection(item.id)}
                  sx={{
                    py: 1.25,
                    "&:hover": { background: "rgba(112, 224, 177, 0.1)" },
                  }}
                >
                  <ListItemIcon sx={{ color: "#70e0b1", minWidth: 42 }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
        </Box>
      </Drawer>
    </nav>
  );
};

export default Navbar;
